import axios from '@/src/api/axios_init'

const METERS_BASE_URL = '/meters'
const AVAILABLE_YEARS_URL = '/available-years'

type AvailableYearsQuery = {
  locationId: number
}

type AvailableYearsByCompanyQuery = {
  companyId: string
}

export const getAvailableMeterYears = (query: AvailableYearsQuery) => {
  return axios.get(`${METERS_BASE_URL}/locations/${query.locationId}${AVAILABLE_YEARS_URL}`)
}

export const getAvailableMeterYearsByCompany = (query: AvailableYearsByCompanyQuery) => {
  return axios.get(`${METERS_BASE_URL}/companies/${query.companyId}${AVAILABLE_YEARS_URL}`)
}
